module.exports = __webpack_public_path__ + "fonts/montserrat-semibold-webfont.be92a5d.woff";